import sdWanImg from "public/network-services/sd-wan.png";

export const INTRO_CONSTANTS = {
  title: "Intelligent Networking, Simplified by OneMind",
  description: [
    "Modern enterprises need networks that are agile, secure, and built to scale. OneMind delivers cloud-native networking solutions—SDN, SD-WAN, wired, and wireless—with centralized control, automation, and optimized performance.",
    "Seamlessly connect cloud, data centers, and branch locations with a network that’s fully managed, always secure, and ready for what’s next.",
  ],
  image: sdWanImg,
  imageHeight: "240px",
};
